// this file added by Bearer Web Developer
import { getFunctions, httpsCallable } from 'firebase/functions';
import { firebaseApp } from '../bearer-api';
import { TCancellationCost } from '../../states/cancellationCostState';
export type TCustomerOrderCancellationCostCheckerRequest = {
    transport_id: string;
}
export type TCustomerOrderCancellationCostCheckerError = {
    code: 499 | 401 | 402 | 410 | 422 | 434 | 421 | 500;
    status: 'Server Error' | 'Client Error';
    message: string;
}
export type TCustomerOrderCancellationCostCheckerSuccess = {
    status: 'Successful';
    code: 200;
    message: string;
    cancelling_state_code: TCancellationCost, // 2.1 || 2.2.2 || 2.2.1 || 3.1 || 3.2
    time_n: number,
    time_m: number,
    cancellation_fee: number,
    waiting_fee: number,
    total_cancellation: number,
    cancellation_fee_validity_for_client_app: number,

}
export type TCustomerOrderCancellationCostCheckerResponse = TCustomerOrderCancellationCostCheckerSuccess | TCustomerOrderCancellationCostCheckerError

const customerOrderCancellationCostChecker = async (data: TCustomerOrderCancellationCostCheckerRequest): Promise<TCustomerOrderCancellationCostCheckerResponse | void> => { // void type added by Bearer Web Developer
    try {
        console.log(data);
        const functions = getFunctions(firebaseApp, 'australia-southeast2'); // add the location string as you call getFunctions by Bearer Web Developer
        const t = httpsCallable<TCustomerOrderCancellationCostCheckerRequest, TCustomerOrderCancellationCostCheckerResponse>(functions, 'customerOrderCancellationCostCheckerSecondGen');
        const result = await t(data);
        return result.data;

    } catch (err: unknown) {
        console.error(err); // modify by Bearer Web Developer
        console.error((err as { message: string })?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer
    }
};
export default customerOrderCancellationCostChecker;